//在vue组件中访问vuex模块中的getters/action/state https://www.cnblogs.com/caimuguodexiaohongmao/p/11854228.html
//https://vuex.vuejs.org/zh/guide/getters.html
export default{
    namespaced: true,
    state:{
        dpd:'', 
    },
    mutations:{
         setDriverPositionDatas(state,value){
            state.dpd=value;
         }     
    },
    actions:{
        saveDriverPositionDatas({commit},value){
            // if(value!=undefined && value!='' && JSON.stringify(value)!='{}'){
            //     commit("setDriverPositionDatas",JSON.stringify(value));
            // }
            commit("setDriverPositionDatas",JSON.stringify(value));
        }
        
    },
    //放在外面公共的getters里面，方便调用
    // getters:{
    //     getdpd:state=>{
    //         return state.dpd
    //     }
    // }


}


// WEBPACK FOOTER //
// ./src/store/modules/driverPosition.js